import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkDialog } from './uitk-dialog.esm.js';
import styles from './uitk-dialog.css';

var getClassNameList = classNames.bind(styles);
var UitkFullscreenDialogTheme;
(function (UitkFullscreenDialogTheme) {
    UitkFullscreenDialogTheme["CANVAS"] = "uitk-dialog-fullscreen-bg-canvas";
    UitkFullscreenDialogTheme["DARK"] = "uitk-dialog-fullscreen-bg-dark";
    UitkFullscreenDialogTheme["DEFAULT"] = "uitk-dialog-fullscreen-bg-default";
})(UitkFullscreenDialogTheme || (UitkFullscreenDialogTheme = {}));
var UitkFullscreenDialog = /** @class */ (function (_super) {
    __extends(UitkFullscreenDialog, _super);
    function UitkFullscreenDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkFullscreenDialog.prototype.render = function () {
        var _a = this.props, className = _a.className, wideContent = _a.wideContent, theme = _a.theme;
        var wrapperClassNames = getClassNameList('uitk-dialog-fullscreen', theme, className, {
            'uitk-dialog-wide-content': wideContent
        });
        return React.createElement(UitkDialog, __assign({}, this.props, { className: wrapperClassNames }));
    };
    UitkFullscreenDialog.displayName = 'UitkFullscreenDialog';
    UitkFullscreenDialog.defaultProps = {
        theme: UitkFullscreenDialogTheme.DEFAULT,
        wideContent: false
    };
    return UitkFullscreenDialog;
}(React.Component));

export { UitkFullscreenDialog, UitkFullscreenDialogTheme };
